import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialCard({
  text,
  author
}: {
  text: string;
  author: string;
}) {
  return <div className="bg-white rounded-[10px] p-6 shadow-[0_2px_16px_rgba(0,0,0,0.06)] border-l-[3px] border-gold" data-id="element-171">
      <div className="flex gap-0.5 mb-2.5" data-id="element-172">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-173" />)}
      </div>
      <p className="italic text-[#333] text-[0.95rem] mb-4" data-id="element-174">{text}</p>
      <span className="text-[0.82rem] text-[#888] font-bold" data-id="element-175">{author}</span>
    </div>;
}